export default __webpack_public_path__ + "static/Cakes_Bakes-409854124a746a45656307e07d9e66e5.jpg";